export const workspaceSettingsNavItems = [
  {
    labelKey: 'workspaceSettings.nav.label',
    icon: 'gear',
    navKey: 'workspaceSettings',
    placement: 'bottom',
    to: { name: 'WorkspaceSettings' },
  },
] as const
